const DataService = {
  get: key => {
    const value = window.localStorage.getItem(key)
    return JSON.parse(JSON.stringify(value))
  },
  set: (key, value) => {
    window.localStorage.setItem(key, JSON.stringify(value))
  },
  remove: key => {
    window.localStorage.removeItem(key)
  }
}

export default DataService
